module.exports = __webpack_public_path__ + "img/logistics2.0ab29ebb.png";